import { Container } from 'react-bootstrap'

import NavbarPages from '../NavbarPages'
import HeaderPages from '../HeaderPages'
import KiveUso from '../../../Resourses/products/kive-uso-comercial.svg'

const imgHeader = "./images/productos/header-productos-kive-cinta-transparente.jpg";
const imgThumbIzq = "./images/productos/kive-cinta-adhesiva-transparente/kive-cinta-adhesiva-transparente-0.jpg";
const altText = "CINTAS ADHESIVAS TRANSPARENTES";

const detailLine1 = "CINTAS";
const detailLine2 = "ADHESIVAS TRANSPARENTES";

const imgTable ="./images/productos/kive/cuadro-kive-cinta-transparente.jpg";

const imgThumb1 = './images/productos/kive-cinta-adhesiva-transparente/kive-cinta-adhesiva-transparente-1.jpg';
const imgThumb1Alt = 'CINTAS ADHESIVAS TRANSPARENTES';

const imgThumb2 = './images/productos/kive-cinta-adhesiva-transparente/kive-cinta-adhesiva-transparente-2.jpg';
const imgThumb2Alt = 'Packaging de CINTAS ADHESIVAS TRANSPARENTES';

const imgThumb3 = './images/productos/kive-cinta-adhesiva-transparente/kive-cinta-adhesiva-transparente-3.jpg';
const imgThumb3Alt = 'CINTA Adhesivas empaquetadas';


const CintaAdhesivaTransparente = () => {
  return (
    <Container className='mb-0'>
        <NavbarPages className="p-0" />
        <div className='row'>
          <div className='col-12 mb-4'>
            <HeaderPages img={imgHeader} alt={"Productos Kive Cintas"} />
          </div>
          <div className='col-12 col-sm-6 col-md-5 productos__imgContainer'>
            <img 
              src={imgThumbIzq} 
              alt={altText} 
              className='d-block w-100 productos__imgContainer--img' 
              loading='lazy'/>
          </div>
          <div className='col-12 col-sm-12 col-md-7 productos__vert--int mb-4 mt-1'>
            <div className='row productos__detail'>
              <div className='col-12'>
                <p className='productos__detail--tipo'>{detailLine1}</p>
                <p className='productos__detail--caracteristica'>{detailLine2}</p>
                <img src={KiveUso} className='d-block productos__detail--svg' alt='' loading="lazy" />
              </div>
              <div className='col-12 productos__detail'>
                <img  src={imgTable} 
                      className='d-block w-100' 
                      alt={altText}
                      loading="lazy" />
              </div>
            </div>
          </div>
          <div className='col-12 col-sm-12 col-md-12 productos__vert mb-4 mt-1'>
            <p className='site_text productos__text--int mb-0'> 
              Cintas adhesivas de polipropileno de corte fácil, ideal para el uso en manualidades, oficinas, escuelas, comercios.<br/>
              Facilitan un sellado ligero en embalajes livianos, sobres, papeles, etc.
            </p>
          </div>
        </div>
        <div className='row'>
        
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb1} className='d-block w-100 p-0 m-0 ' alt={ imgThumb1Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb2} className='d-block w-100 p-0 m-0 ' alt={ imgThumb2Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb3} className='d-block w-100 p-0 m-0 ' alt={ imgThumb3Alt} loading="lazy" />
            </div>
        </div>       
      </Container>
    
  )
}

export default CintaAdhesivaTransparente